import {
  CalculateOfferRequest,
  CalculateOfferResponse,
  ConfirmSeatsPlanRequest,
  ConfirmSeatsPlanResponse,
  ConfirmedOrderModel,
  CreateAppleSessionRequest,
  CreateAppleSessionResponse,
  GetOrderByIdResponse,
  InitOrderRequest,
  InitOrderResponse,
  PayOrderGuestBookingRequest,
  PayOrderRequest,
  PayOrderResponse,
  SeatsPlanResponse,
  SessionResponse,
  ShareSeatsPlanRequest,
  ShareSeatsPlanResponse,
  ValidateAppleSessionRequest,
  ValidateAppleSessionResponse,
} from './models';
import { createMutation, createQuery } from '../../libs';

const sessionsUrl = 'showtimes';
export const ordersUrl = 'orders';
const offersUrl = 'offers';
const guestOrdersUrl = 'guest-users/orders';
const ApplePayCardsUrl = 'cards';

export const useInitOrder = createMutation<InitOrderResponse, InitOrderRequest>({
  method: 'post',
  url: ordersUrl,
});

export const useGetSession = createQuery<SessionResponse>({
  method: 'get',
  url: `${sessionsUrl}/:sessionId`,
});

export const useGetOrderById = createQuery<GetOrderByIdResponse>({
  method: 'get',
  url: `${ordersUrl}/:id`,
});

export const useGuestBookingGetOrderById = createQuery<GetOrderByIdResponse>({
  method: 'get',
  url: `${guestOrdersUrl}/:id`,
  transformRequest: (data, headers) => {
    headers['Content-Type'] = 'application/json';
    delete headers.Authorization;
    return JSON.stringify(data);
  },
});

export const useGetSeatsPlan = createQuery<SeatsPlanResponse>({
  method: 'get',
  url: `${sessionsUrl}/:sessionId/seats`,
});

export const useShareSeatsPlan = createMutation<
  ShareSeatsPlanResponse,
  ShareSeatsPlanRequest
>({
  method: 'post',
  url: `${sessionsUrl}/:sessionId/share-seats`,
});

export const useCalculateOffer = createMutation<
  CalculateOfferResponse,
  CalculateOfferRequest
>({
  method: 'post',
  url: `${offersUrl}/:offerId/calculate`,
});

export const useConfirmSeatsPlan = createMutation<
  ConfirmSeatsPlanResponse,
  ConfirmSeatsPlanRequest
>({
  method: 'post',
  url: `${ordersUrl}/:orderId/seats`,
});

export const usePayOrder = createMutation<
  PayOrderResponse,
  PayOrderRequest,
  'id',
  unknown
>({
  method: 'post',
  url: `${ordersUrl}/:id/pay`,
});

export const useGuestBookingPayOrder = createMutation<
  PayOrderResponse,
  PayOrderGuestBookingRequest,
  'id',
  unknown
>({
  method: 'post',
  url: `${guestOrdersUrl}/:id/pay`,
  // this function to remove Authorization in case logged-in user and incomplete profile
  transformRequest: (data, headers) => {
    headers['Content-Type'] = 'application/json';
    delete headers.Authorization;
    return JSON.stringify(data);
  },
});

export const useDeleteOffer = createMutation<
  { order: ConfirmedOrderModel },
  unknown,
  'id'
>({
  method: 'delete',
  url: `${ordersUrl}/:id/offers`,
});

// TODO: add types to the following service
export const useCheckCard = createMutation<
  unknown,
  unknown,
  'id',
  {
    cardId: string;
    bin: string;
  }
>({
  method: 'get',
  url: `${ordersUrl}/:id/offers/check-card`,
});

export const useValidateAppleSessionMutation = createMutation<
  ValidateAppleSessionResponse,
  ValidateAppleSessionRequest
>({
  method: 'post',
  url: `${ApplePayCardsUrl}/validate-apple-session`,
});
export const useCreateAppleSessionMutation = createMutation<
  CreateAppleSessionResponse,
  CreateAppleSessionRequest
>({
  method: 'post',
  url: `${ApplePayCardsUrl}/create-apple-session`,
});
